import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Box, Typography, Grid } from "@mui/material";
import ReplyIcon from "@mui/icons-material/Reply";
import SendIcon from "@mui/icons-material/Send";
import { useGetList } from "react-admin";
import { employeeRequests } from "api/employeeApi";

const VacationRequestPreview = ({ data, onBack, onConfirm, isCreate }) => {
  const { data: reasons } = useGetList(employeeRequests.getLeaveReasonsSelect(), {
    filter: data.employeeId ? { employeeId: data.employeeId } : {},
  });
  const reason = reasons?.find(r => r.id === data.reasonId);

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
      >
        {data.periods?.map((period, index) => (
          <TableContainer
            component={Paper}
            sx={{ mb: 2 }}
            key={index}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", p: 1, backgroundColor: "#f5f5f5" }}
            >
              Период {index + 1}
            </Typography>
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell
                    component="th"
                    sx={{ fontWeight: "bold", width: 200 }}
                  >
                    От дата
                  </TableCell>
                  <TableCell>{period.dateFrom || 'Не е посочена "от дата"'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    component="th"
                    sx={{ fontWeight: "bold" }}
                  >
                    До дата
                  </TableCell>
                  <TableCell>{period.dateTo || 'Не е посочена "до дата"'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    component="th"
                    sx={{ fontWeight: "bold" }}
                  >
                    Брой работни дни
                  </TableCell>
                  <TableCell>{period.numberOfDays || "Не са посочени(изчислени) броят дни"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    component="th"
                    sx={{ fontWeight: "bold" }}
                  >
                    Заместник
                  </TableCell>
                  <TableCell>{period.substituteName || "Не е посочен заместник"}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ))}

        {data.contracts?.length > 0 && (
          <TableContainer
            component={Paper}
            sx={{ mb: 2 }}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", p: 1, backgroundColor: "#f5f5f5" }}
            >
              Трудови договори
            </Typography>
            <Table size="small">
              <TableBody>
                {data.contracts.map(contract => (
                  <TableRow key={contract.contractNumber}>
                    <TableCell
                      component="th"
                      sx={{ fontWeight: "bold", width: 200 }}
                    >
                      Договор № {contract.contractNumber}
                    </TableCell>
                    <TableCell>
                      {[contract.facultyName, contract.positionName].filter(Boolean).join(" — ") || "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <TableContainer component={Paper}>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell
                  component="th"
                  sx={{ fontWeight: "bold", width: 200 }}
                >
                  Основание
                </TableCell>
                <TableCell>
                  {(reason?.note ? reason.note : reason?.name) || "Не е посочено основание"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  component="th"
                  sx={{ fontWeight: "bold" }}
                >
                  Коментар
                </TableCell>
                <TableCell>{data.comment || "Няма"}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          <Button
            variant="contained"
            onClick={onBack}
            color="error"
          >
            <ReplyIcon /> Назад
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={onConfirm}
            startIcon={<SendIcon />}
          >
            {isCreate ? 'Заяви отпуск' : 'Запази промените'}
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default VacationRequestPreview;
